<template>
  <div>
    <div class="space-between align-center">
      <div class="align-center flex-1">
        <div class="filter-icon">
          <img src="/img/filter.svg" alt="" />
        </div>

        <div class="search-wrappper">
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Search here...">
            </b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <button
        type="button"
        class="btn mulai btn-secondary font-bold"
        @click="handleNew"
      >
        <fa-icon icon="edit" class="my-icon" />&nbsp; ADD NEW PAGE
      </button>
    </div>
    <br />
    <br />
    <!-- Main table element -->
    <b-table
      show-empty
      stacked="md"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-secondary"
          @click="handleEdit(row.item)"
        >
          <fa-icon icon="pencil-alt" class="my-icon" />&nbsp;Edit
        </b-button>
        <!-- <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-danger"
          @click="handleDelete(row.item)"
        >
          <fa-icon icon="minus-circle" class="my-icon" />&nbsp;Delete
        </b-button> -->
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal
      v-model="addModal"
      id="addModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="addModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">{{editData ? "Edit Page" : "Create New Page"}}</h3>
        <br />
        <label>Page Type</label>
        <br />
        <b-form-input
          placeholder="Page Type"
          v-model="inputData.type"
        ></b-form-input>
        <br />
        <label>Page Title</label>
        <br />
        <b-form-input
          placeholder="Page Title"
          v-model="inputData.title"
        ></b-form-input>
        <br />
        <label>Content</label>
        <quill-editor
          class="editor"
          v-model="inputData.content"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @ready="onEditorReady($event)"
        >
        </quill-editor>
        <br />
        <div class="upload-image">
          <div class="upload-image__item">
            <div class="upload-image__top">
              <div class="image-container">
                <img
                  class="image-container-img"
                  :src="inputData.thumbnail_src"
                  alt="img"
                  style="height: 108px;"
                />
                <div
                  class="img-remove"
                  v-show="inputData.thumbnail_src != '/img/thumbnail.png'"
                  @click="removeImage()"
                >
                  X Remove
                </div>
              </div>
            </div>
            <div class="upload-image__bottom">
              <input
                type="file"
                :name="inputData.thumbnail"
                id="inputIcon"
                class="hidden-input"
                @change="changePhoto()"
              />
              <label for="inputIcon" class="file-upload">
                <fa-icon icon="upload" class="my-icon" />
                Upload Photo
              </label>
            </div>
          </div>
        </div>
        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="handleSave"
          >
            SAVE
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'font': [] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'video']
          ]
        }
      },
      editData: false,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "id",
          label: "#ID"
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "title",
          label: "Page Title",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      addModal: false,
      inputData: {
        id: 0,
        type: "",
        title: "",
        content: "",
        thumbnail: null,
        thumbnail_src: "/img/thumbnail.png",
        remove_old: false
      },
      showLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },

  mounted() {
    this.totalRows = this.items.length;
    this.pageList();
  },

  methods: {
    ...mapActions({
      getPageList: types.GET_PAGE_LIST,
      createPage: types.CREATE_PAGE,
      updatePage: types.UPDATE_PAGE
    }),
    onEditorBlur(quill) {
      // console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      // console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      // console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.inputData.content = html;
    },
    pageList() {
      this.isBusy = true;
      this.getPageList()
        .then(response => {
          this.items = response;
          this.totalRows = response.length;
          this.isBusy = false;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleNew() {
      this.addModal = true;
      this.editData=false;
      this.inputData = {
        id: 0,
        type: "",
        title: "",
        content: "",
        thumbnail: null,
        thumbnail_src: "/img/thumbnail.png",
        remove_old: false
      }
    },
    removeImage() {
      this.inputData.thumbnail_src = "/img/thumbnail.png";
      this.inputData.thumbnail = null;
      this.inputData.remove_old = true;
    },
    changePhoto() {
      var fileData = event.target.files[0];
      this.inputData.thumbnail = fileData;
      this.inputData.thumbnail_src = URL.createObjectURL(fileData);
      this.inputData.remove_old = false;
    },
    handleEdit(item) {
      this.editData = true;
      this.addModal = true;
      this.inputData = {
        id: item.id,
        type: item.type,
        title: item.title,
        content: item.content,
        thumbnail: null,
        thumbnail_src: item.thumbnail,
        remove_old: false
      }
    },
    handleSave() {
      if(this.editData) {
        this.editPage();
      } else {
        this.addPage();
      }
    },
    handleDelete(index) {
      this.$bvModal.msgBoxConfirm('Delete this data?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            this.deleteTestimonial({id:index.id})
              .then(response => {
                this.pageList();
                this.showMessageBox("Deleted", "Success", "success");
              })
              .catch(error => {
                this.showMessageBox(error, "Failed", "success");
              });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "success");
        });
    },
    addPage() {
      this.showLoading = true;
      let newFormData = new FormData();
      newFormData.append("type", this.inputData.type);
      newFormData.append("title", this.inputData.title);
      newFormData.append("content", this.inputData.content);
      if(this.inputData.thumbnail) {
        newFormData.append("thumbnail", this.inputData.thumbnail);
      }
      this.createPage(newFormData)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.addModal = false;
          this.showLoading = false;
          this.pageList();
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
    },
    editPage() {
      this.showLoading = true;
      let newFormData = new FormData();
      newFormData.append("id", this.inputData.id);
      newFormData.append("type", this.inputData.type);
      newFormData.append("title", this.inputData.title);
      newFormData.append("content", this.inputData.content);
      if(this.inputData.thumbnail) {
        newFormData.append("thumbnail", this.inputData.thumbnail);
      }
      if(this.inputData.remove_old) {
        newFormData.append("remove_old", this.inputData.remove_old);
      }
      this.updatePage(newFormData)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.addModal = false;
          this.showLoading = false;
          this.pageList();
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
        .msgBoxOk(message, {
          title: title,
          size: "sm",
          buttonSize: "sm",
          okVariant: variant,
          centered: true
        })
        .then(value => {
        })
        .catch(err => {
        });
    }
  }
};
</script>

<style>
.search-wrapper {
  width: 100%;
  max-width: 222px;
}

.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>